import { RouterView } from "vue-router";

export const NoviceGuideRouting = {
  path: "/novice",
  redirect: "/novice/video-list",
  component: RouterView,
  name: "novice",
  meta: { title: "新手视频", icon: "xinshoushipin" },
  children: [
    {
      path: "/novice/video-list",
      name: "novice-video-list",
      component: () =>
        import(
          /* webpackChunkName: "novice-video-list" */ "@/views/novice-guide/video-list/index.vue"
        ),
      meta: { title: "新手视频", icon: "xinshoushipin" },
    },
  ],
};
